import React from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

const linkTypes = {
	add: {
		linkClassName: 'btn btn-primary btn-inverse pull-right',
		iClassName: 'fa fa-plus hidden-sm hidden-md hidden-lg',
		spanClassName: 'hidden-xs'
	},
	back: {
		linkClassName: 'btn btn-primary btn-inverse pull-right',
		iClassName: 'fa fa-angle-left hidden-sm hidden-md hidden-lg',
		spanClassName: 'hidden-xs'
	},
	clone: {
		linkClassName: 'btn btn-sm btn-primary btn-inverse',
		iClassName: 'fa fa-clone hidden-sm hidden-md hidden-lg',
		spanClassName: 'hidden-xs'
	},
	edit: {
		linkClassName: 'btn btn-sm btn-primary btn-inverse',
		iClassName: 'fa fa-pencil hidden-sm hidden-md hidden-lg',
		spanClassName: 'hidden-xs'
	},
	formBack: {
		linkClassName: 'btn btn-primary btn-inverse'
	},
	link: {
		linkClassName: ''
	},
	view: {
		linkClassName: 'btn btn-sm btn-primary btn-inverse',
		iClassName: 'fa fa-eye hidden-sm hidden-md hidden-lg',
		spanClassName: 'hidden-xs'
	}
};

const handleBack = (e, history) => {
	e.preventDefault();
	history.goBack();
};

const IconLink = (props) => {
	const {type, to, text, linkClassName, iClassName, spanClassName, history, ...rest} = props;

	const linkClass = (linkClassName === '' && linkTypes[type].linkClassName) ? linkTypes[type].linkClassName : linkClassName;
	const iClass =  (iClassName === '' && linkTypes[type].iClassName) ? linkTypes[type].iClassName : iClassName;
	const spanClass = (spanClassName === '' && linkTypes[type].spanClassName) ? linkTypes[type].spanClassName : spanClassName;

	if( (type === 'back' || type === 'formBack') && history) {
		return (
			// eslint-disable-next-line jsx-a11y/anchor-is-valid
			<a href="" className={linkClass} onClick={e => handleBack(e, history)}>
				{
					iClass && <i className={iClass} aria-hidden="true"/>
				}
				{
					spanClass
						? <span className={spanClass}>{text}</span>
						: text
				}
			</a>
		);
	}

	return linkTypes[type] && (
		<Link to={to} className={linkClass} {...rest}>
			{
				iClass && <i className={iClass} aria-hidden="true"/>
			}
			{
				spanClass
				? <span className={spanClass}>{text}</span>
				: text
			}
		</Link>
	);
};

IconLink.defaultProps = {
	linkClassName: '',
	iClassName: '',
	spanClassName: '',
	history: null
};

IconLink.propTypes = {
	type: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	linkClassName: PropTypes.string,
	iClassName: PropTypes.string,
	spanClassName: PropTypes.string,
	history: PropTypes.object
};

export default IconLink;
